/*
 Array utils
*/

export const insertInArrayByIndex = (array, index, value) => {
  return [
    ...array.slice(0, index),
    value,
    ...array.slice(index + 1)
  ]
}

export const removeInArrayByIndex = (array, index) => {
  return [
    ...array.slice(0, index),
    ...array.slice(index + 1)
  ]
}

export const removeFromArrayById = (array, id) => (
  array.filter(item => item.id !== id)
)

export const updateInArrayById = (array, entity) => {
  const index = array.findIndex(item => item.id === entity.id)

  // If entity not found
  if (index < 0) {
    return [
      ...array,
      entity
    ]
  }

  // Or updating entity
  return insertInArrayByIndex(
    array,
    index,
    { ...array[index], ...entity }
  )
}
